import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Logo } from './Logo';
const COLUMNS = [{
  title: 'Explorar',
  links: [{
    label: 'Productos',
    href: '#productos'
  }, {
    label: 'Blog',
    href: '#blog'
  }, {
    label: 'Contacto',
    href: '#contacto'
  }]
}, {
  title: 'Legal',
  links: [{
    label: 'Política de privacidad',
    href: '#privacidad'
  }, {
    label: 'Términos',
    href: '#terminos'
  }]
}];
export function Footer() {
  return <footer id="blog" className="relative w-full border-t border-ink/[0.07] bg-white pb-12 pt-20 sm:pt-24" data-id="element-90" data-mp="38h81hlebwon">
      <div className="mx-auto w-full max-w-content px-6 lg:px-8" data-id="element-91" data-mp="3ldaobi2207ky">
        <div className="grid grid-cols-1 gap-14 md:grid-cols-[1.4fr_1fr_1fr]" data-id="element-92" data-mp="3qd6sbhar3z0i">
          <div data-id="element-93" data-mp="3qf9suv9j5ajh">
            <Logo size="md" showTagline data-id="element-94" data-mp="29zgli2s8ywn6" />
            <p className="mt-6 max-w-xs text-[13.5px] font-light leading-relaxed text-ink-muted" data-id="element-95" data-mp="29ydxq3q81abh">
              Recursos digitales para aprender, crear y emprender.
            </p>
            <ul className="mt-7 flex flex-wrap gap-2.5" data-id="element-96" data-mp="3l8qxu8j60rtk">
              {['Aprender', 'Crear', 'Emprender'].map(tag => <li key={tag} className="rounded-full border border-ink/[0.08] bg-paper-alt px-3 py-1 text-[12px] font-light text-ink-soft" data-id="element-97" data-mp="3gc0hdk3g7u7m">
                  {tag}
                </li>)}
            </ul>
          </div>

          {COLUMNS.map(column => <nav key={column.title} aria-label={column.title} data-id="element-98" data-mp="80nskgzggmbt">
              <h2 className="text-[12.5px] font-medium uppercase tracking-[0.16em] text-ink-muted" data-id="element-99" data-mp="335trjf5jnhj">
                {column.title}
              </h2>
              <ul className="mt-6 space-y-3.5" data-id="element-100" data-mp="ctqmiq859xsj">
                {column.links.map(link => <li key={link.label} data-id="element-101" data-mp="qthyklf3p43w">
                    <a href={link.href} className="text-[14px] font-light text-ink-soft transition-colors hover:text-electric" data-id="element-102" data-mp="qujkjkxnnb0e">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
            </nav>)}
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-ink/[0.08] pt-9 sm:flex-row sm:items-center sm:justify-between" data-id="element-103" data-mp="13tan0d7kry6p">
          <p className="text-[12.5px] font-light text-ink-muted" data-id="element-104" data-mp="18k93bcskcw9y">
            © {new Date().getFullYear()} Creativo Digital. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center gap-5" data-id="element-105" data-mp="1hkffmvcizq7j">
            <span className="text-[12.5px] font-light text-ink-muted" data-id="element-106" data-mp="1hiujx2eh6183">
              @creativodigitalstudio
            </span>
            <a href="https://creativodigital.shop" className="inline-flex items-center gap-1.5 text-[12.5px] font-medium text-electric transition-colors hover:text-violetd" data-id="element-107" data-mp="1mhxmmg6zfvcw">
              creativodigital.shop
              <ArrowUpRightIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-108" data-mp="3tb18nwmogii1" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}